import * as THREE from 'three';

export class SelectedMaterial extends THREE.ShaderMaterial {
  constructor(color: THREE.ColorRepresentation = 0x3399ff) {
    super({
      uniforms: {
        uColor: { value: new THREE.Color(color) },
      },
      vertexShader: `
        varying vec3 vNormal;
        varying vec3 vViewDir;

        void main() {
          vNormal = normalize(normalMatrix * normal);
          vec4 viewPosition = modelViewMatrix * vec4(position, 1.0);
          vViewDir = normalize(-viewPosition.xyz);
          gl_Position = projectionMatrix * viewPosition;
        }
      `,
      fragmentShader: `
        uniform vec3 uColor;
        varying vec3 vNormal;
        varying vec3 vViewDir;

        void main() {
          float rim = 1.0 - dot(vNormal, vViewDir);
          rim = smoothstep(0.1, 0.8, rim);

          float base = 0.3;
          float intensity = 0.8 * rim;

          vec3 glow = uColor * (intensity + base);

          gl_FragColor = vec4(glow, 1.0);
        }
      `,
      transparent: false,
      depthWrite: true,
    });
  }

  update() {
    // No-op: animation removed
  }
}
